webpackJsonp([10],{

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Styles_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Styles_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_main_content_main_content_less__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Components_main_content_main_content_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_Components_main_content_main_content_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_breadcrumbs_breadcrumbs_less__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Components_breadcrumbs_breadcrumbs_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Components_breadcrumbs_breadcrumbs_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_card_card_less__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Components_card_card_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_Components_card_card_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_page_nav_page_nav_less__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Components_page_nav_page_nav_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_Components_page_nav_page_nav_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_WebComponents_greedy_nav__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_WebComponents_a11y__ = __webpack_require__(4);










var a11y = new __WEBPACK_IMPORTED_MODULE_6_WebComponents_a11y__["a" /* A11y */]();
a11y.init();

/***/ })

},[121]);


// WEBPACK FOOTER //
// persons-list.js